import {Injectable} from '@angular/core';
import {BehaviorSubject, ReplaySubject, Subject} from 'rxjs';
import {filter} from 'rxjs/operators';
import {Hotkeys} from './hotkeys.enum';

@Injectable()
export class HotkeysService {
  private events = new ReplaySubject(1, 1000);

  constructor() {
  }

  emit(bind: string) {
    console.log('emit bind', bind);
    this.events.next(bind);
  }

  on(bind: string) {
    return this.events.pipe(filter((event: string) => Hotkeys[event] == bind));
  }
}
